import React from 'react'
import { Link } from 'react-router-dom'
import { FcExternal } from 'react-icons/fc'
import CloseIcon from '@material-ui/icons/Close'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '../../../components/sharedComponents/CustomButtons/Button'
import CardTitle from '../../../components/sharedComponents/CardTitle'
import Card from '../../../components/sharedComponents/Card/Card'
import CardHeader from '../../../components/sharedComponents/Card/CardHeader'
import CardBody from '../../../components/sharedComponents/Card/CardBody'
import { Centered, useStyles } from './style'

const BillsPage = ({
  bills,
  clase,
  onChange,
  currency,
  onSubmit,
  onDelete,
  onUpdate,
  update,
  unidad,
  loading,
  setUpdate,
}) => {
  const classes = useStyles()
  const classesBills = Array.isArray(clase) ? clase : []
  return (
    <>
      <CardTitle title="Facturación." />
      <div style={{ margin: '10px' }}>
        <Card>
          <CardHeader>
            {unidad ? (
              <h3>Tipo factura</h3>
            ) : (
              <>
                <h3>Seleccione una unidad de negocio primero</h3>
                <Link to="/home">Selección</Link>
              </>
            )}
          </CardHeader>
          {unidad && (
            <CardBody>
              <form
                onSubmit={onSubmit}
                style={{ margin: '8px', paddingRight: '2px' }}
                noValidate
                autoComplete="off"
              >
                <div>
                  <Grid alignContent="center" container spacing={3}>
                    <Grid item xs={12} md={2}>
                      <TextField
                        id="standard-select-currency"
                        select
                        required
                        fullWidth
                        label="Clase de Factura"
                        value={currency.clase}
                        onChange={(event) => onChange(event, 'clase')}
                        helperText="Seleccione la clase factura"
                      >
                        {classesBills.map((option) => (
                            <MenuItem
                              key={option.Clase_factura}
                              value={option.Clase_factura}
                            >
                              {option.Clase_factura}
                            </MenuItem>
                          ))}
                        {/* <MenuItem>Hola</MenuItem> */}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        required
                        fullWidth
                        type="number"
                        id="filled-name"
                        label="Signo"
                        value={currency.signo}
                        onChange={(event) => onChange(event, 'signo')}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <TextField
                        required
                        fullWidth
                        type="number"
                        id="filled-name"
                        label="Signo Neto"
                        value={currency.signo_neto}
                        onChange={(event) => onChange(event, 'signo_neto')}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        required
                        fullWidth
                        type="number"
                        disabled
                        id="filled-name"
                        label="Unidad de Negocio"
                        value={currency.unidad_negocio_id}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      {!loading.state ? (
                        <Button
                          fullWidth
                          type="onSubmit"
                          color={update ? 'primary' : 'warning'}
                        >
                          {update ? 'Actualizar' : 'Crear'}
                        </Button>
                      ) : (
                        <Centered>
                          <CircularProgress />
                        </Centered>
                      )}
                    </Grid>
                  </Grid>
                </div>
              </form>
            </CardBody>
          )}
        </Card>
        {unidad && (
          <Card>
            <CardHeader>
              <h3>Lista de Facturas</h3>
            </CardHeader>
            <CardBody>
              <List component="div" key="Lista_Principal">
                {!loading.loading ? (
                  Array.isArray(bills) &&
                  bills.map((bill) => (
                    <div key={bill.UUID}>
                      <ListItem id={bill.UUID}>
                        <ListItemAvatar>
                          <Avatar>
                            <FcExternal style={{ size: '50px' }} />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={`Clase Factura: ${bill.CLASE} `}
                          secondary={`Signo: ${bill.SIGNO} Signo Neto:${bill.SIGNO_NETO}`}
                        />
                        <ListItemSecondaryAction>
                          <IconButton
                            onClick={() => onUpdate(bill.UUID)}
                            edge="start"
                            aria-label="edit"
                          >
                            <EditIcon
                              className={classes.tableActionButtonIcon}
                              style={{ color: ' #43a047' }}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() => onDelete(bill.UUID)}
                            edge="end"
                            aria-label="delete"
                          >
                            <DeleteIcon
                              className={classes.tableActionButtonIcon}
                              style={{ color: 'rgb(244, 67, 54)' }}
                            />
                          </IconButton>
                          {update && (
                            <IconButton
                              onClick={() => setUpdate(false)}
                              edge="end"
                              aria-label="close"
                            >
                              <CloseIcon />
                            </IconButton>
                          )}
                        </ListItemSecondaryAction>
                      </ListItem>
                    </div>
                  ))
                ) : (
                  <Centered>
                    <CircularProgress />
                  </Centered>
                )}
              </List>
            </CardBody>
          </Card>
        )}
      </div>
    </>
  )
}

export default BillsPage
